import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'cv-public-record-single-field',
	templateUrl: './public-record-single-field.component.html'
})
export class PublicRecordSingleFieldComponent implements OnInit {

	@Input() labelPublicRecord: any;
	@Input() dataPublicRecord: any;

	@Output() copiedEvent = new EventEmitter<any>();

	constructor() { }
	ngOnInit(): void {
		return;
	}

	copyToClipboard() {
		if (this.dataPublicRecord) {
			navigator.clipboard.writeText(this.dataPublicRecord);
			this.copiedEvent.emit();
		}
	}

}
